const SUPPORTED_LANGUAGES = ['de', 'en', 'fr', 'nl'];
const COUNTRY_NAME_LOCALES = {
  de: 'de-DE',
  en: 'en-GB',
  fr: 'fr-FR',
  nl: 'nl-BE',
};
const COUNTRY_CODES = 'AF AL DZ AS AD AO AI AQ AG AR AM AW AU AT AZ BS BH BD BB BY BZ BJ BM BT BO BQ BA BW BV BR IO BN BG BF BI CV KH CM CA KY CF TD CL CN CX CC CO KM CG CD CK CR CI HR CU CW CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FK FO FJ FI FR GF PF TF GA GM GE DE GH GI GR GL GD GP GU GT GG GN GW GY HT HM VA HN HK HU IS IN ID IR IQ IE IM IL IT JM JP JE JO KZ KE KI KP KR KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MQ MR MU YT MX FM MD MC MN ME MS MA MZ MM NA NR NP NL NC NZ NI NE NG NU NF MK MP NO OM PK PW PS PA PG PY PE PH PN PL PT PR QA RE RO RU RW BL SH KN LC MF PM VC WS SM ST SA SN RS SC SL SG SX SK SI SB SO ZA GS SS ES LK SD SR SJ SE CH SY TW TJ TZ TH TL TG TK TO TT TN TR TM TC TV UG UA AE GB US UM UY UZ VU VE VN VG VI WF EH YE ZM ZW'.split(' ');

function getCountryNames(countryCode) {
  return SUPPORTED_LANGUAGES.reduce((names, language) => {
    const displayNames = new Intl.DisplayNames([COUNTRY_NAME_LOCALES[language]], {
      type: 'region',
    });

    names[language] = displayNames.of(countryCode) || countryCode;
    return names;
  }, {});
}

function getCountryOptions(language) {
  return COUNTRY_CODES
    .filter(countryCode => countryCode !== 'BE')
    .map((countryCode) => {
      const names = getCountryNames(countryCode);

      return {
        label: names[language] || names.en,
        names,
        value: countryCode,
      };
    });
}

export {
  getCountryOptions,
};